const IconVerified = ({ ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      version='1.2'
      viewBox='0 0 1408 1378'
      width='20'
      height='20'
      {...props}
    >
      <g>
        <g>
          <g>
            <path
              fillRule='evenodd'
              fill="currentColor"
              class='s0'
              d='m1407.9 689.7c0 50.7-86.6 91-97.4 138.4-11 48.9 49.4 122.7 28.1 166.9-21.6 44.9-117.1 43.6-147.8 82.2-30.9 38.7-8.4 131.6-47.1 162.5-38.5 30.9-124-11.5-168.8 10.2-44.1 21.3-64 114.8-112.9 126-47.4 10.8-105.8-64.5-156.5-64.4-50.6 0-108.9 75.4-156.3 64.6-48.9-11-69-104.5-113.1-125.8-44.9-21.6-130.3 20.9-168.8-9.9-38.8-30.9-16.4-123.7-47.4-162.4-30.8-38.6-126.3-37.1-148-82-21.3-44.2 39-118 27.9-166.9-10.8-47.4-97.5-87.6-97.6-138.3 0-50.6 86.6-90.9 97.3-138.3 11.1-49-49.3-122.7-28.1-166.9 21.6-44.9 117.2-43.6 147.9-82.2 30.9-38.8 8.4-131.6 47.1-162.6 38.5-30.8 123.9 11.6 168.8-10.1 44.1-21.4 64-114.9 112.9-126 47.4-10.9 105.8 64.4 156.4 64.4 50.7 0 109-75.4 156.4-64.7 48.9 11.1 68.9 104.6 113.1 125.8 44.9 21.7 130.3-20.8 168.8 9.9 38.8 30.9 16.4 123.8 47.3 162.5 30.8 38.5 126.4 37.1 148 82 21.4 44.1-38.9 118-27.8 166.9 10.8 47.4 97.5 87.5 97.6 138.2zm-326.5-272.6c-23.8-24.1-62.7-24.4-86.7-0.6l-399.7 395-160.1-168.4c-23.3-24.6-62.1-25.6-86.7-2.2-24.5 23.3-25.5 62.2-2.1 86.7l203.1 213.7c11.4 12 27.1 18.8 43.5 19.1q0.5 0 1 0c16.1 0 31.6-6.4 43.1-17.7l444-438.9c24.1-23.8 24.4-62.6 0.6-86.7z'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default IconVerified
